(() => {
  const selector = '.m26 select[data-variant]';

  function updatePrice(select) {
    const option = select.selectedOptions[0];
    const card = select.closest('.m26-card');
    if (!option || !card) return;

    const price = card.querySelector('.m26-price');
    if (price && option.dataset.money) {
      price.textContent = option.dataset.money;
      price.setAttribute('aria-live', 'polite');
    }
  }

  function prepare(scope) {
    scope.querySelectorAll(selector).forEach(select => {
      for (const option of select.options) {
        if (option.dataset.money && !option.dataset.priceLabelled) {
          option.textContent += ' — ' + option.dataset.money;
          option.dataset.priceLabelled = 'true';
        }
      }
      updatePrice(select);
    });
  }

  document.addEventListener('change', event => {
    if (event.target.matches(selector)) updatePrice(event.target);
  });

  document.addEventListener('shopify:section:load', event => {
    prepare(event.target);
  });

  window.addEventListener('pageshow', () => prepare(document));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      prepare(document);
    }, { once: true });
  } else {
    prepare(document);
  }
})();
(() => {
  async function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('.m26-grid');
    try {
      let nextUrl = grid.querySelector('[data-catalogue-next]')?.dataset.url;
      const visited = new Set();
      while (nextUrl) {
        const url = new URL(nextUrl, location.href);
        url.searchParams.set('section_id', root.dataset.sectionId);
        if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid catalogue pagination');
        visited.add(url.href);
        const response = await fetch(url.href, {credentials: 'same-origin'});
        if (!response.ok) throw new Error('Catalogue request failed: ' + response.status);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const batch = doc.querySelector('.m26-grid');
        if (!batch) throw new Error('Catalogue batch missing');
        for (const card of batch.querySelectorAll('.m26-card')) grid.append(card);
        nextUrl = batch.querySelector('[data-catalogue-next]')?.dataset.url;
      }
      grid.querySelectorAll('[data-catalogue-next]').forEach(node => node.remove());
      // Load each enabled wine collection independently, retaining its collection order.
      for (const source of root.querySelectorAll('[data-wine-source]')) {
        const sourceGrid = source.querySelector('[data-wine-grid]');
        let next = sourceGrid.querySelector('[data-catalogue-next]')?.dataset.url;
        const seen = new Set();
        while (next) {
          const url = new URL(next, location.href);
          url.searchParams.set('section_id', root.dataset.sectionId);
          if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Invalid wine pagination');
          seen.add(url.href);
          const response = await fetch(url.href, {credentials: 'same-origin'});
          if (!response.ok) throw new Error('Wine collection request failed: ' + response.status);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const batch = doc.querySelector('[data-wine-source="' + source.dataset.wineSource + '"] [data-wine-grid]');
          if (!batch) throw new Error('Wine collection batch missing');
          for (const card of batch.querySelectorAll('.m26-card')) sourceGrid.append(card);
          next = batch.querySelector('[data-catalogue-next]')?.dataset.url;
        }
        sourceGrid.querySelectorAll('[data-catalogue-next]').forEach(node => node.remove());
      }
      root.dispatchEvent(new CustomEvent('shopify:section:load', {bubbles: true}));
    } catch (error) {
      root.dataset.ready = '';
      root.querySelector('.m26-count').textContent = 'Unable to load all gifts. Please refresh.';
      console.error(error);
      return;
    }
    const byId = new Map();
    const entries = [];
    for (const card of [...grid.children]) {
      const types = card.dataset.category.split(/\s+/).filter(Boolean);
      let entry = byId.get(card.dataset.product);
      if (entry) { types.forEach(type => entry.types.add(type)); card.remove(); continue; }
      entry = {card, types: new Set(types), title: card.dataset.title, price: Number(card.dataset.price), available: card.dataset.available, brand: ''};
      byId.set(card.dataset.product, entry);
      entries.push(entry);
    }
    // Keep Wine Gift Sets tied to the existing catalogue selection and order.
    const giftSetCards = entries.filter(entry => entry.types.has('wine')).map(entry => entry.card);
    const wineGroups = [...root.querySelectorAll('[data-wine-source]')].map(source => ({
      source,
      grid: source.querySelector('[data-wine-grid]'),
      limit: Number(source.dataset.limit) || 8,
      page: 1,
      cards: source.dataset.wineSource === 'sets' ? giftSetCards : [...source.querySelectorAll('.m26-card')]
    }));
    for (const group of wineGroups) {
      if (group.source.dataset.wineSource === 'sets') continue;
      for (const card of group.cards) {
        let entry = byId.get(card.dataset.product);
        if (entry) { entry.types.add('wine'); continue; }
        entry = {card, types: new Set(['wine']), title: card.dataset.title, price: Number(card.dataset.price), available: card.dataset.available, brand: ''};
        byId.set(card.dataset.product, entry);
        entries.push(entry);
      }
    }
    const brands = ['Teeling','Redbreast','Dingle','Drumshanbo','Taittinger','Kopke','Louis Roederer','Grey Goose','Skellig Six18','Woodford Reserve','Jackford','La Chouffe','St. Bernardus','Duvel','Chimay','Hope Beer','Graham','Bollinger','Riedel','Guinness'];
    for (const entry of entries) {
      const vendor = entry.card.dataset.vendor.trim();
      if (vendor && !/martin/i.test(vendor)) entry.brand = vendor;
      else entry.brand = brands.find(brand => entry.title.toLowerCase().includes(brand.toLowerCase())) || '';
      entry.card.dataset.brand = entry.brand;
    }
    const filters = Object.fromEntries([...root.querySelectorAll('[data-filter]')].map(e => [e.dataset.filter, e]));
    const sort = root.querySelector('[data-sort]');
    const tabs = [...root.querySelectorAll('.m26-tabs [data-category]')];
    const count = root.querySelector('.m26-count');
    const nav = root.querySelector('.m26-pagination:not([data-wine-pagination])');
    const more = root.querySelector('[data-load-more]');
    const clear = root.querySelector('.m26-clear');
    const size = Number(root.dataset.pageSize) || 8;
    for (const brand of [...new Set(entries.map(e => e.brand).filter(Boolean))].sort()) filters.brand.add(new Option(brand,brand));
    let page = 1;
    let previousCategory = null;
    let previousWineFilters = '';
    function update(writeUrl = true) {
      const category = filters.category.value;
      if (category === 'secret-santa' && previousCategory !== category) {
        for (const entry of entries) {
          const select = entry.card.querySelector('select[data-variant]');
          if (select && entry.card.dataset.santaVariant) {
            select.value = entry.card.dataset.santaVariant;
            select.dispatchEvent(new Event('change', {bubbles: true}));
          }
        }
      }
      previousCategory = category;
      const price = filters.price.value;
      const brand = filters.brand.value;
      const available = filters.availability.value;
      const wineFilters = JSON.stringify([category, price, brand, available]);
      if (wineFilters !== previousWineFilters) {
        wineGroups.forEach(group => { group.page = 1; });
        previousWineFilters = wineFilters;
      }
      const [min,max] = price === 'all' ? [0, Infinity] : price.split(':').map(Number);
      const selected = entries.filter(e => (category === 'all' || e.types.has(category)) && e.price >= min && e.price < max && (brand === 'all' || e.brand === brand) && (available === 'all' || e.available === available));
      if (sort.value === 'price-asc') selected.sort((a,b) => a.price-b.price || a.title.localeCompare(b.title));
      if (sort.value === 'price-desc') selected.sort((a,b) => b.price-a.price || a.title.localeCompare(b.title));
      if (sort.value === 'title') selected.sort((a,b) => a.title.localeCompare(b.title));
      const pages = Math.max(1,Math.ceil(selected.length/size));
      page = Math.min(Math.max(1,page),pages);
      entries.forEach(e => {e.card.hidden=true;});
      wineGroups.forEach(group => {
        group.source.hidden = true;
        group.cards.forEach(card => { card.hidden = true; });
      });
      grid.hidden = category === 'wine';
      let wineCount = 0;
      if (category === 'wine') {
        const matches = new Set(selected.map(entry => entry.card.dataset.product));
        for (const group of wineGroups) {
          // Subsection previews follow manual order even when the main sort is changed.
          const matchingCards = group.cards.filter(card => matches.has(card.dataset.product));
          const isGiftSets = group.source.dataset.wineSource === 'sets';
          const cards = matchingCards.slice(0, isGiftSets ? page * size : group.page * group.limit);
          const winePagination = group.source.querySelector('[data-wine-pagination]');
          if (winePagination) winePagination.hidden = cards.length >= matchingCards.length;
          group.source.hidden = cards.length === 0;
          for (const card of cards) { card.hidden = false; group.grid.append(card); }
          wineCount += cards.length;
        }
      } else {
        selected.slice(0,page*size).forEach(e => {e.card.hidden=false; grid.append(e.card);});
      }
      tabs.forEach(tab => {if (tab.dataset.category===category) tab.setAttribute('aria-current','page'); else tab.removeAttribute('aria-current');});
      count.textContent = root.dataset.count.replace('{count}',category === 'wine' ? wineCount : selected.length);
      root.querySelector('.m26-empty').hidden = (category === 'wine' ? wineCount : selected.length) > 0;
      nav.hidden = category === 'wine' || page >= pages;
      clear.hidden = category === 'all' && price === 'all' && brand === 'all' && available === 'all';
      if (writeUrl) {
        const url = new URL(location.href);
        const state = {gift_type:category,gift_price:price,gift_brand:brand,gift_availability:available,gift_sort:sort.value,gift_page:page};
        for (const [key,value] of Object.entries(state)) {if (value==='all'||value==='featured'||value===1) url.searchParams.delete(key); else url.searchParams.set(key,value);}
        history.replaceState(null,'',url);
      }
    }
    function readUrl() {
      const params = new URLSearchParams(location.search);
      for (const [key,select] of Object.entries(filters)) {const value=params.get({category:'gift_type',price:'gift_price',brand:'gift_brand',availability:'gift_availability'}[key])||'all'; select.value=[...select.options].some(o=>o.value===value)?value:'all';}
      const s=params.get('gift_sort')||'featured';sort.value=[...sort.options].some(o=>o.value===s)?s:'featured';
      page=Number(params.get('gift_page'))||1;update(false);
    }
    tabs.forEach(tab => tab.addEventListener('click',e=>{e.preventDefault();filters.category.value=tab.dataset.category;page=1;update();}));
    Object.values(filters).forEach(select=>select.addEventListener('change',()=>{page=1;update();}));
    sort.addEventListener('change',()=>{page=1;update();});
    clear.addEventListener('click',()=>{Object.values(filters).forEach(e=>e.value='all');page=1;update();});
    root.querySelector('.m26-hero .m26-button').addEventListener('click',()=>{Object.values(filters).forEach(e=>e.value='all');sort.value='featured';page=1;update();});
    function move(step) {page+=step;update();root.querySelector('.m26-toolbar').scrollIntoView({block:'start',behavior:'smooth'});}
    more.addEventListener('click',()=>{page+=1;update();});
    root.querySelector('[data-wine-load-more]')?.addEventListener('click',()=>{page+=1;update();});
    wineGroups.forEach(group => {
      group.source.querySelector('[data-wine-collection-more]')?.addEventListener('click', () => {
        group.page += 1;
        update(false);
      });
    });
    window.addEventListener('popstate',readUrl);
    const panel=root.querySelector('.m26-filter-panel');
    const media=matchMedia('(max-width:767px)');
    panel.open=!media.matches;media.addEventListener('change',()=>{panel.open=!media.matches;});
    readUrl();
  }
  document.querySelectorAll('.m26').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.m26').forEach(init));
})();
